<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
        <div>
        </div>
        <a-button type="primary" @click="addFqaDict">
          {{ $t('ADD') || '添加' }}
        </a-button>
      </div>
      <a-table
        style="width: 100%"
        :scroll="{ y: 'calc(100vh - 410px)' }"
        default-expand-all-rows
        row-key="id"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        :data-source="table.data">
        <a-table-column
          data-index="name"
          title="FAQ">
        </a-table-column>
        <a-table-column
          data-index="remark"
          :title="$t('REMARK') || '备注'"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="date"
          :title="$t('OPERATION')||'操作'">
          <template slot-scope="text, record">
            <a-button
              type="link"
              @click="editFqaDict(record.id)">{{ $t('EDIT') || '编辑' }}
            </a-button>
            <a-button
              type="link"
              @click="editFqaDictData(record.id)">{{ $t('DATA') || '数据' }}
            </a-button>
            <a-button
              type="link"
              @click="deleteFqaDict(record.id)">{{ $t('REMOVE') || '删除' }}
            </a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal
      :footer="null"
      :title="form.data.id?'字典编辑':'字典添加'"
      @close="closeForm"
      v-model="form.visible">
      <fqa-dict-edit
        v-if="form.visible"
        :fqa-dict-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </fqa-dict-edit>
    </a-modal>
    <a-modal
      :footer="null"
      title="字典数据"
      v-model="dataForm.visible"
      @close="getFqaDictList">
      <fqa-dict-data-list
        v-if="dataForm.visible"
        :fqa-dict-id="dataForm.data.id"/>
    </a-modal>
  </a-card>
</template>

<script>
import {
  _deleteFqaDict,
  _queryFqaDicts,
} from '@/api/fqaDictApi';
import FqaDictEdit from './FqaDictEdit.vue';
import FqaDictDataList from './FqaDictDataList.vue';

async function getFqaDictList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const { content, totalElements } = await _queryFqaDicts({
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = content;
  this.table.query.total = totalElements;
}

function addFqaDict() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editFqaDict(fqaDictId) {
  this.form.data.id = fqaDictId;
  this.form.visible = true;
}

function editFqaDictData(fqaDictId) {
  this.dataForm.data.id = fqaDictId;
  this.dataForm.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getFqaDictList();
}

async function deleteFqaDict(fqaDictId) {
  this.$confirm({
    title: this.$t('CONFIRM_REMOVE'),
    content: '',
    onOk: async () => {
      await _deleteFqaDict(fqaDictId);
      this.$message.success(this.$t('REMOVE_SUCCESS'));
      this.getFqaDictList();
    },
  });
}

export default {
  name: 'FqaDictList',
  components: {
    FqaDictDataList,
    FqaDictEdit,
  },
  data() {
    return {
      form: {
        data: {
          id: null,
          name: '',
          code: '',
          isActive: 'YES',
          remark: '',
        },
        visible: false,
      },
      dataForm: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'name',
          order: 'ascend',
        },
      },
    };
  },
  methods: {
    getFqaDictList,
    deleteFqaDict,
    editFqaDict,
    editFqaDictData,
    addFqaDict,
    closeForm,
  },
  created() {
    this.getFqaDictList();
  },
};
</script>

<style scoped>

</style>
